import { NoResponse } from "@it-tc/legacy-api";
import emptySplitApi from "./emptySplitApi";

const extendedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    markNotificationAsRead: builder.mutation<boolean, number>({
      invalidatesTags: ["Notification"],
      transformResponse: (response: NoResponse) =>
        response.responseCode === "S0001",
      query: (id) => ({
        method: "PUT",
        url: `${location.origin}/individualexamscheduler/services/notification/v1/notification/status.json`,
        body: {
          id,
        },
      }),
    }),
  }),
});

export const { useMarkNotificationAsReadMutation } = extendedApi;
